/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Wallet_LabelInputs */

const en_login_page_wallet_label = /** @type {(inputs: Login_Page_Wallet_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with a browser wallet`)
};

const de_login_page_wallet_label = /** @type {(inputs: Login_Page_Wallet_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit einer Browser-Wallet fortfahren`)
};

const pt_br2_login_page_wallet_label = /** @type {(inputs: Login_Page_Wallet_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar com uma carteira do navegador`)
};

const tr_login_page_wallet_label = /** @type {(inputs: Login_Page_Wallet_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarayıcı cüzdanıyla devam et`)
};

const zh_cn2_login_page_wallet_label = /** @type {(inputs: Login_Page_Wallet_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用浏览器钱包继续`)
};

const zh_hk2_login_page_wallet_label = /** @type {(inputs: Login_Page_Wallet_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用瀏覽器錢包繼續`)
};

const ko_kr2_login_page_wallet_label = /** @type {(inputs: Login_Page_Wallet_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브라우저 지갑으로 계속`)
};

const ru_ru2_login_page_wallet_label = /** @type {(inputs: Login_Page_Wallet_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжить с браузерным кошельком`)
};

const es_419_login_page_wallet_label = /** @type {(inputs: Login_Page_Wallet_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar con una billetera del navegador`)
};

/**
* | output |
* | --- |
* | "Continue with a browser wallet" |
*
* @param {Login_Page_Wallet_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_wallet_label = /** @type {((inputs?: Login_Page_Wallet_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Wallet_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_wallet_label(inputs)
	if (locale === "de") return de_login_page_wallet_label(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_wallet_label(inputs)
	if (locale === "tr") return tr_login_page_wallet_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_wallet_label(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_wallet_label(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_wallet_label(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_wallet_label(inputs)
	return es_419_login_page_wallet_label(inputs)
});